// Patch to fix https://github.com/FormidableLabs/victory/issues/961
import type * as React from 'react'
import {VictoryLine, VictoryArea} from 'victory'

const cloneAndOverrideAll = (dataKeys: unknown[] | undefined) => {
  if (!dataKeys) {
    return dataKeys
  }

  const clone: unknown[] & {all?: null} = [...dataKeys]
  clone.all = null
  return clone
}

const patchComponent = <P>(Component: React.ComponentClass<P>) => {
  class Patched extends Component {
    static displayName = `Patched (${Component.displayName ?? Component.name})`
    static whyDidYouRender = true
    _dataKeys: unknown[] | undefined = []
    dataKeys: unknown[] | undefined = []
    constructor(props: P) {
      super(props)
      this._dataKeys = cloneAndOverrideAll(this.dataKeys)
      Object.defineProperty(this, 'dataKeys', {
        configurable: true,
        enumerable: true,

        get() {
          return this._dataKeys
        },

        set(dataKeys) {
          this._dataKeys = cloneAndOverrideAll(dataKeys)
        },
      })
    }
  }

  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(Patched, Component)
  }

  return Patched
}

export const PatchedVictoryLine = patchComponent(
  VictoryLine as React.ComponentClass<React.ComponentProps<typeof VictoryLine>>,
)
export const PatchedVictoryArea = patchComponent(
  VictoryArea as React.ComponentClass<React.ComponentProps<typeof VictoryArea>>,
)
